import type { FC } from "react"

import { useAdjustmentHistoryLotsColumns } from "../../hooks/useAdjustmentHistoryLotsColumns"

import { AerosBaseTable } from "@/components/Tables/Aeros/components/AerosBaseTable"
import type { AdjustmentHistoryLot, InventoryAdjustmentType } from "@/graphql/codegen/graphql"

interface AdjustmentHistoryLotsTableProps {
  lots: AdjustmentHistoryLot[]
  adjustmentType: InventoryAdjustmentType
  isPrinting: boolean
  onPalletLabelPrint: (palletReferenceNumber: number) => void
}

export const AdjustmentHistoryLotsTable: FC<AdjustmentHistoryLotsTableProps> = ({
  lots,
  adjustmentType,
  isPrinting,
  onPalletLabelPrint,
}) => {
  const columns = useAdjustmentHistoryLotsColumns({ adjustmentType, isPrinting, onPalletLabelPrint })

  return (
    <AerosBaseTable
      features={{
        tanstackOptions: {
          data: lots,
          columns,
          getRowId: (row) => row.inventoryAdjustmentLotId,
        },
      }}
    />
  )
}
